import { Outlet, Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Package, Calculator, FolderOpen, Users } from 'lucide-react';
import { cn } from '@/lib/utils';

const navigation = [
  { name: 'Gösterge Paneli', href: '/', icon: LayoutDashboard },
  { name: 'Malzemeler', href: '/materials', icon: Package },
  { name: 'İşçilik', href: '/labor', icon: Users },
  { name: 'Hesaplama', href: '/calculator', icon: Calculator },
  { name: 'Projeler', href: '/projects', icon: FolderOpen },
];

export const Layout = () => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background">
      {/* Sidebar */}
      <aside className="fixed inset-y-0 left-0 z-50 w-64 bg-card border-r border-border">
        <div className="flex h-full flex-col">
          {/* Logo */}
          <div className="flex h-16 items-center border-b border-border px-6">
            <Calculator className="h-6 w-6 text-primary" />
            <span className="ml-2 text-xl font-bold text-foreground">MaliyetPro</span>
          </div>

          {/* Navigation */}
          <nav className="flex-1 space-y-1 px-3 py-4">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;
              const Icon = item.icon;
              
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={cn(
                    'flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-primary text-primary-foreground shadow-sm'
                      : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                  )}
                >
                  <Icon className="h-5 w-5" />
                  {item.name}
                </Link>
              );
            })}
          </nav>

          {/* Footer */}
          <div className="border-t border-border p-4">
            <p className="text-xs text-muted-foreground">
              © 2024 MaliyetPro
            </p>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="pl-64">
        <div className="min-h-screen">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;